<template>
  <div class="overlay">
    <slot />
  </div>
</template>

<style scoped lang="postcss">
.overlay {
  @apply absolute inset-0 z-[970] flex flex-col items-center justify-center;
  background-color: rgba(0, 0, 0, 0.2); /* workaround to allow nested items to set opacity > 0.2 */
}
</style>
